import api from './api';


export async function fetchETF() {
  const response = await api.get('etfs/full');
  return response.data;
}

export async function searchETFRecommendations(query, limit = 6) {
  const response = await api.post('semantic/search', { query, limit });
  return response.data;
}

export async function fetchETFDetail(identifier) {
  const response = await api.get(`semantic/etfs/${encodeURIComponent(identifier)}`);
  return response.data;
}

export async function continueETFConversation({
  identifier,
  originalQuery,
  question,
  history,
}) {
  const response = await api.post('semantic/conversation', {
    identifier,
    original_query: originalQuery || '',
    question,
    history: history.slice(-10),
  });
  return response.data;
}
